import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

interface ChartData {
  name: string;
  amount: number;
  color: string;
}

interface FundAllocationChartProps {
  chartData: ChartData[];
}

export const FundAllocationChart = ({ chartData }: FundAllocationChartProps) => {
  const totalAmount = chartData.reduce((sum, item) => sum + item.amount, 0);

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  return (
    <div className="h-[400px] mt-8">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={chartData}
            dataKey="amount"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={150}
            labelLine={false}
            label={({ name, value }) => {
              const percentage = ((value / totalAmount) * 100).toFixed(0);
              return `${name} (${percentage}%)`;
            }}
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip 
            formatter={(value: number) => [formatCurrency(value), 'Amount']}
            contentStyle={{ backgroundColor: 'white', borderRadius: '8px' }}
          />
        </PieChart>
      </ResponsiveContainer>
      <div className="text-center mt-4 text-sm text-muted-foreground">
        Total Allocation: {formatCurrency(totalAmount)}
      </div>
    </div>
  );
};